const isNull = (value) => (value === null || value === '');
const isNegative = (value) => value < 0;

export const creditIncreaseAmountValidator = (handler) => {
    return (value) => {
        const isValid = isNull(value) || !isNegative(parseFloat(value));
        handler(isValid);
        return isValid;
    };
};

export const creditWriteOffAmountValidator = (creditBalance, handler) => {
    return (value) => {
        if (isNull(value)) return true;

        const valueAsNumber = parseFloat(value);
        const balanceInDollars = (creditBalance / 100);

        const valueIsValid = !isNegative(valueAsNumber);
        const amountIsValid = valueAsNumber <= balanceInDollars;
        
        const isValid = valueIsValid && amountIsValid;
        handler(isValid);
        return isValid;
    };
};

export const creditRefundAmountValidator = creditWriteOffAmountValidator;
